export var pi = Math.PI;
export var tau = 2 * Math.PI;
export var e = Math.E;
export var phi = 1.6180339887498948; // eslint-disable-line no-loss-of-precision


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/plain/number/constants.js
// module id = qvpl
// module chunks = 2